(function($, undefined) {
	
	'use strict';
	var utils;
	var groupForm;
	var formValidator;
	var groups = [];
	
	
	var onGroupFormBtnClick = function() {
		var thisForm = $(this.form);
		formValidator.validateForm(thisForm);
		
		if (!thisForm.hasClass('has-error')) {
			var groupName = $('[name=field2]', thisForm).val();
			fetchGroups(function(groups) {
				if (groupNameAlreadyExists(groups, groupName)) {
					$('.name-already-taken', thisForm).slideDown(300);
				}
				else {
					$('.name-already-taken', thisForm).slideUp(300);
					
					if ($('[name=field4]', thisForm).val().length === 0) {
						$('[name=field4]', thisForm).val(groupName); //  + generateGroupCodeDigits()
					}
					thisForm.submit();	
				}
			});
		}	
	};
	
	var generateGroupCodeDigits = function() {
		return generateDigitsFromTime(3);
	};
	
	var generateDigitsFromTime = function(numberOfDigits) {
		if (numberOfDigits > 4) {
			numberOfDigits = 4;
		} 
		else if (numberOfDigits <= 0) {
			return "";
		}
		var currentDate = new Date();
		var timeDigits = "" + currentDate.getHours() + currentDate.getMinutes();
		
		return timeDigits.substr(timeDigits.length - numberOfDigits, timeDigits.length);
	};
	
	var fetchGroups = function(callback = () => {}) {
		if (groups.length === 0) {
			utils.fetchGenDatasJson({"field1": "groupe"}, function(response) {
				callback(JSON.parse(response));
			});
		} else {
			callback(groups);
		}
	};
	
	var groupNameAlreadyExists = function(groups, name) {
		return groups.filter((item) => item.field2 == name).length > 0;
	};
	
	var init = function () {
		utils = Fw.component.models().utils;
		formValidator = Fw.component.models().form;
		groupForm = $('.add-group-form');
		
		$('.js-form-btn', groupForm).on('click', onGroupFormBtnClick);
	};
	
	$(window).ready(function () {
		init();
	});
	
})(jQuery);
